export const CardCoverScreens = {
  AddCover: 0,
  SelectCover: 1,
} as const;
